import { Toolbar } from "../toolbar/toolbar";
import Footer from "../Footer/Footer";

const Tnc = () => {
  const txt =
    "Access to our sites is permitted on a temporary basis, and we reserve the right to withdraw or amend the service we provide on our sites without notice. We shall not be liable if for any reason our sites are unavailable at any time or for any period.* From time to time, we may restrict access to some parts, or the entirety of, our sites to users who have registered with us.* If you choose, or you are provided with, a username or user identification code, password or any other information as part of our security procedures, you must treat that information as confidential, and you must not disclose it to any third party. We have the right to disable any username or user identification code or password, whether chosen by you or allocated by us, at any time, if in our opinion you have failed to comply with any of these Terms or the terms of any of our programs.* You are responsible for making all arrangements necessary for you to have access to our sites. You are also responsible for ensuring that all persons who access our sites through your internet connection are aware of these Terms, and that they comply with them.* In respect of any and all material (including data, photographs, images, sound and text) that you send to us or otherwise contribute to our sites (the User Content), you represent and warrant that:* you are entitled to grant the licence granted to us under clause 3 of these Terms (the Licence)* the User Content does not, and our use of it (including as contemplated by the Licence) will not, infringe any third party’s intellectual property rights (including trade marks, copyright, moral rights, database rights, design rights, confidentiality rights and all other rights having equivalent or similar effect), or other proprietary rights, or personality rights or rights of privacy* the User Content does not, and our use of it (including as contemplated by the Licence) will not, violate any law regarding unfair competition, anti-discrimination or false advertising;* all information that you disclose to us is complete and accurate;* the User Content is not defamatory, trade libellous, unlawfully threatening or unlawfully harassing and does not otherwise breach any applicable law or regulation;* the User Content does not contain any advertising, or any political or religious message, and is not obscene, indecent, blasphemous, offensive or sexually explicit;* the User Content does not contain viruses, trojans, worms, logic bombs or other material that is malicious or technologically harmful.* We have the right to remove any User Content from our sites if, in our opinion, that User Content does not comply with these Terms or for any other reason. We also have the right to disclose your identity to any third party who claims that the User Content violates that third party’s rights or is otherwise unlawful.* By providing us with User Content, you grant us a non-exclusive, perpetual, irrevocable, transferrable, sub-licensable licence to use the User Content.* The Licence granted under these Terms includes the right for us (and our sub-licensees) to modify, reproduce, distribute, publicly perform, communicate, make available and display the User Content (including by reproducing and distributing the User Content (including as modified) in marketing and promotional media relating to us and/or our sites). We are under no obligation to use the User Content.* As between you and us, you irrevocably waive all moral rights (including under the Copyright, Designs and Patents Act 1988) in relation to the User Content. These Terms do not affect your ownership of any copyright (other than moral rights) in the User Content.";

  const arr = txt.split("*");

  return (
    <>
      <div className="">
        <Toolbar />

        <div className="w-full bg-gradient-to-r from-orange-300 to-pink-400  h-[12rem] flex justify-center items-center">
          <p className="text-white text-3xl md:text-4xl font-bold">
            {" "}
            Terms and Conditions
          </p>
        </div>

        <div className="flex justify-center bg-red-200 ">
          <div className=" mx-3 px-5 md:w-[60%]">
            <p className="text-end my-5">Last Updated: 03/09/2023</p>

            <div className="text-lg text-start font-bold md:text-xl mt-10">
              <p className="">
                Please read these terms and conditions ("Terms") carefully
                before using the website.
              </p>
              <p className="my-5">
                <a
                  href="http://www.reproneetlearning.com"
                  className="text-red-500 mx-0 font-bold text-lg md:text-xl"
                >
                  www.reproneetlearning.com
                </a>{" "}
                (the "Website") operated by Reproneet Learning "us," "we," or
                "our".
              </p>
              <p className="my-5">
              The website contents are handled by Dr. Monalisa Shekhar Singh.
              </p>
            </div>

            {/* <ul className="list-disc p-5">
              {arr.map((data) => {
                return <li className=" text-lg my-5 md:text-lg">{data}</li>;
              })} */}
            {/* </ul> */}

            <p>
              1.1 Access to our sites is permitted on a temporary basis, and we
              reserve the right to withdraw or amend the service we provide on
              our sites without notice. We shall not be liable if for any reason
              our sites are unavailable at any time or for any period. 1.2 From
              time to time, we may restrict access to some parts, or the
              entirety of, our sites to users who have registered with us. 1.3
              If you choose, or you are provided with, a username or user
              identification code, password or any other information as part of
              our security procedures, you must treat that information as
              confidential, and you must not disclose it to any third party. We
              have the right to disable any username or user identification code
              or password, whether chosen by you or allocated by us, at any
              time, if in our opinion you have failed to comply with any of
              these Terms or the terms of any of our programmes. 1.4 You are
              responsible for making all arrangements necessary for you to have
              access to our sites. You are also responsible for ensuring that
              all persons who access our sites through your internet connection
              are aware of these Terms, and that they comply with them. 1.5 The
              contents (videos, notes, MCQs) are not downloadable. Printed notes
              are not included in any course purchases. User Content 2.1 In
              respect of any and all material (including data, photographs,
              images, sound and text) that you send to us or otherwise
              contribute to our sites (the User Content), you represent and
              warrant that: (a) you are entitled to grant the licence granted to
              us under clause 3 of these Terms (the Licence); (b) the User
              Content does not, and our use of it (including as contemplated by
              the Licence) will not, infringe any third party’s intellectual
              property rights (including trade marks, copyright, moral rights,
              database rights, design rights, confidentiality rights and all
              other rights having equivalent or similar effect), or other
              proprietary rights, or personality rights or rights of privacy;
              (c) the User Content does not, and our use of it (including as
              contemplated by the Licence) will not, violate any law regarding
              unfair competition, anti-discrimination or false advertising; (d)
              all information that you disclose to us is complete and accurate;
              (e) the User Content is not defamatory, trade libellous,
              unlawfully threatening or unlawfully harassing and does not
              otherwise breach any applicable law or regulation; (f) the User
              Content does not contain any advertising, or any political or
              religious message, and is not obscene, indecent, blasphemous,
              offensive or sexually explicit; and (g) the User Content does not
              contain viruses, trojans, worms, logic bombs or other material
              that is malicious or technologically harmful. 5.2 We have the
              right to remove any User Content from our sites if, in our
              opinion, that User Content does not comply with these Terms or for
              any other reason. We also have the right to disclose your identity
              to any third party who claims that the User Content violates that
              third party’s rights or is otherwise unlawful. Licence of User
              Content 3.1 By providing us with User Content, you grant us a
              non-exclusive, perpetual, irrevocable, transferrable,
              sub-licensable licence to use the User Content. 3.2 The Licence
              granted under these Terms includes the right for us (and our
              sub-licensees) to modify, reproduce, distribute, publicly perform,
              communicate, make available and display the User Content
              (including by reproducing and distributing the User Content
              (including as modified) in marketing and promotional media
              relating to us and/or our sites). We are under no obligation to
              use the User Content. 3.3 As between you and us, you irrevocably
              waive all moral rights (including under the Copyright, Designs and
              Patents Act 1988) in relation to the User Content. These Terms do
              not affect your ownership of any copyright (other than moral
              rights) in the User Content. Our intellectual property rights 4.1
              Unless otherwise stated on our sites (including in these Terms),
              we are the owner or the licensee of all existing and future
              intellectual property rights (including trade marks, copyright,
              database rights, design rights, confidentiality rights and all
              other rights having equivalent or similar effect) in our sites
              (including the material published on it). All such rights are
              reserved. 4.2 Except to the extent that you are obliged by a court
              order or regulatory body to disclose it, you shall keep
              confidential all confidential information belonging to us that we
              may disclose to you. 4.3 You must not use any part of the
              materials on our sites for commercial purposes under any
              circumstance Our liability 5.1 The material on our sites, our
              sites and the services provided via our sites are not intended to
              be advice and you should not rely on them. That material and our
              sites are provided without any guarantees, representations or
              warranties as to their accuracy or freedom from harmful material.
              To the extent permitted by law, we hereby expressly exclude: (a)
              all conditions, representations, warranties and other terms that
              might otherwise be included, whether express or implied; and (b)
              any liability for any direct, indirect or consequential loss or
              damage incurred by any user in connection with our sites or the
              use, inability to use, or results of the use of our sites
              (including reliance on any content displayed on our sites), any
              websites linked to our sites and any materials posted on our
              sites, including, in each case, any liability for loss of income
              or revenue, loss of business, loss of profits or contracts, loss
              of anticipate savings, loss of data, loss of goodwill, wasted
              management or office time, and for any other loss or damage of any
              kind, however arising and whether caused by tort (including
              negligence and negligent misrepresentation), breach of contract or
              otherwise. 5.2 This does not affect our liability for death or
              personal injury arising from our negligence, nor our liability for
              fraud or fraudulent misrepresentation. Indemnity 6.1 You indemnify
              us against each and any loss, liability and cost (including
              reasonable legal expenses) that we may suffer or incur as a result
              of or in connection with any claim against us that results (in
              whole or in part) from a breach by you of your obligations under
              these Terms. Information about you and your visits to our sites
              7.1 We process information about you in accordance with our Data
              Protection and Privacy Policy. By using our sites, you consent to
              that processing and you warrant that all data provided by you is
              accurate. 7.2 We may also obtain information about your use of our
              sites and general internet usage by using a cookie file which is
              stored on the hard drive of your computer. Further details on how
              our sites use cookies is set out in our Data Protection and
              Privacy Policy. Viruses, hacking and other offences 8.1 You must
              not misuse our sites by knowingly introducing viruses, trojans,
              worms, logic bombs or other material which is malicious or
              technologically harmful. You must not attempt to gain unauthorised
              access to our sites, the server on which our sites are stored or
              any server, computer or database connected to our sites. You must
              not attack our sites via a denial-of-service attack or a
              distributed denial-of service attack. We may co-operate with law
              enforcement authorities in relation to any such misuse, including
              by disclosing your identity to them. 8.2 We do not guarantee that
              our sites will be secure or free from bugs or viruses. You are
              responsible for configuring your information technology, computer
              programmes and platform in order to access our sites. You should
              use your own virus protection software. We will not be liable for
              any loss or damage caused by a virus, distributed
              denial-of-service attack, or other technologically harmful
              material that may infect your computer equipment, computer
              programmes, data or other proprietary material due to your use of
              our sites or to your downloading of any content on them, or on any
              website linked to them. Safeguarding 9.1 We are not responsible
              for performing any checks or validations required to ensure the
              safeguarding of children or vulnerable adults. However, we reserve
              the right to restrict access to our sites or any programme run by
              us, and/or to refer information to the appropriate authorities, if
              we suspect that a user who has registered with us has harmed or
              poses a risk of harm to children or vulnerable adults. Linking to
              our sites 10.1 You may link to our home pages, provided you do so
              in a way that is, in our opinion, fair and legal and does not
              damage our reputation or take advantage of it, but you must not
              establish a link in such a way as to suggest any form of
              association, approval or endorsement on our part where none
              exists. 10.2 We reserve the right to withdraw linking permission
              without notice. The websites from which you are linking must
              comply in all respects with the representations and warranties
              above relating to User Content (as if that websites and its
              contents were User Content). 10.3 You must not establish a link
              from any websites that are not owned by you. Our sites must not be
              framed on any other sites, nor may you create a link to any part
              of our sites other than the home page. 10.4 If you wish to make
              any use of material on our sites other than as set out above,
              please contact us. Links from our sites 11.1 Where our sites
              contain links to other sites and resources provided by third
              parties, these links are provided for your information only. We
              have no control over the contents of those sites or resources, and
              accept no responsibility for them or for any loss or damage that
              may arise from your use of them. Variations 12.1 We may revise
              these Terms at any time by amending this page. Please check this
              page from time to time to take notice of any changes we have made,
              as they are binding on you. Some of the provisions contained in
              these Terms may also be superseded by provisions or notices
              published elsewhere on our sites. Jurisdiction and applicable law
              13.1 The Indian courts shall have exclusive jurisdiction in
              relation to all disputes arising out of or in connection with
              these Terms (including claims for set-off and counterclaims),
              including disputes arising out of or in connection with: (i) the
              creation, validity, effect, interpretation, performance or
              non-performance of, or the legal relationships established by,
              these Terms; and (ii) any non-contractual obligations arising out
              of or in connection with these Terms. For such purposes you
              irrevocably submit to the jurisdiction of the English courts. 13.2
              These Terms and any non-contractual obligations arising out of or
              in connection with these Terms shall be governed by and
              interpreted in accordance with, English law. Your questions 14.1
              If you have any questions or concerns about our sites, including
              any concerns regarding any users of our sites, please contact us.
              17.2 We are committed to ensuring that our sites are accessible to
              the widest possible range of people. If you have any questions or
              suggestions regarding the accessibility of our sites, or if you
              have difficulty using any part of them, please contact us.
            </p>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Tnc;
